import { ApplicationEntryEnhancer } from '../../entrypoint';
import { MockEnhancerConfig } from './mockConfig';

export function createMockEnhancer(init: MockEnhancerConfig): ApplicationEntryEnhancer {
    const {
        loader: {
            metric: { list: metricListOverrides },
        },
    } = init;
    return (create) => (config) => {
        const {
            api: { createDashboardApi },
            module: { createMetricModule },
        } = config;
        return create({
            ...config,
            module: {
                ...config.module,
                createMetricModule(config) {
                    return createMetricModule({
                        ...config,
                        provider: {
                            ...config.provider,
                            benchmark: {
                                list: {
                                    ...config.provider.benchmark.list,
                                    // createLoader(init) {
                                    //     const loader =
                                    //         config.provider.benchmark.list.createLoader(
                                    //             init
                                    //         );
                                    //     if (!metricListOverrides) {
                                    //         return loader;
                                    //     }
                                    //     return {
                                    //         async useLoad(adapter, context, query) {
                                    //             return metricListOverrides;
                                    //         },
                                    //     };
                                    // },
                                },
                            },
                        },
                    });
                },
            },
        });
    };
}
